export default function PortalLogo() {
  return <span className="bs-portal-logo-frame"><img className="bs-portal-logo" src="/blendsafe-portal-logo.png" alt="BlendSafe — Skincare × Medication Safety" /></span>;
}
